const translations = {
    code: "ka",
    fields: {},
    messages: {
        confirmed: "დადასტურება არასწორია.",
        email: "ამ ველში შეყვანილი ელფოსტა არასწორია.",
        required: "ეს ველი სავალდებულოა.",
        required_if: "ეს ველი სავალდებულოა.",
        length: 'ეს ველი უნდა შეიცავდეს ზუსტად "{length}" სიმბოლოს.',
        min: 'ეს ველი უნდა შეიცავდეს მინიმუმ "{length}" სიმბოლოს.',
        max: 'ეს ველი უნდა შეიცავდეს მაქსიმუმ "{length}" სიმბოლოს.',
        max_value: "ეს ველი უნდა იყოს {_value_}-ზე ნაკლები.",
        min_value: "ეს ველი უნდა იყოს {_value_}-ზე მეტი.",
        oneOf: "ეს ველი უნდა იყოს ერთ-ერთი {_value_} მნიშვნელობიდან.",
        date_format: "ველი უნდა იყოს სწორი თარიღი/დრო.",
    }
}

export default translations;
